import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import { List, Toast, Modal, Button } from 'antd-mobile';
import * as services from '../../projects/services';
import { createBrowserHistory } from "history";
import './style.less';
const history = createBrowserHistory();
export default class IntegralDetail extends Component {
    constructor(props) {
        super(props);
        this.state =
            {
                publicId: this.props.match.params.publicId,
                integralD: [],
                modal1: false,
                upPW: { PublicId: this.props.match.params.publicId, newPassword: '', oldPassword: '', cardcode: '', newPassword2: '' },
            }
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        const { publicId } = this.state;
        services.GetIntegralD(publicId, '正在查询，请稍后').then(data => {
            if (data.status === 0) {
                let upPW = this.state.upPW;
                upPW.cardcode = data.result.cardcode;
                this.setState({ integralD: data.result, upPW: upPW });

            } else {
                Toast.offline(data.message);
            }

        })
    }
    open = key => () => {
        this.setState({ modal1: true });
    }
    editmobile = key => () => {
        history.push(`/members/integral/editMobole/${this.state.publicId}`);
        history.go();
    }
    onClose = key => () => {
        this.setState({
            [key]: false,
        });
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let upPW = this.state.upPW;
        upPW[name] = value;
        this.setState({ upPW: upPW });
    }
    Editpw = key => () => {
        if (this.verification()) {

            services.Updatepw(this.state.upPW, '正在修改，请稍后').then(data => {
                if (data.status === 0) {
                    Toast.success(data.message);
                    this.setState({ modal1: false });
                } else {
                    Toast.offline(data.message);
                }
            })
        }
    }
    verification = () => {

        if (this.state.upPW.oldPassword === '') {
            Toast.info('旧密码不能为空！', 1);
            return false;
        }
        if (this.state.upPW.newPassword === '' || this.state.upPW.newPassword.length < 6) {
            Toast.info('新密码格式错误！', 1);
            return false;
        } if (this.state.upPW.newPassword2 === '' || this.state.upPW.newPassword2.length < 6) {
            Toast.info('新密码格式错误！', 1);
            return false;
        }
        if (this.state.upPW.newPassword !== this.state.upPW.newPassword2) {
            Toast.info('密码输入不一致!', 1);
            return false;
        }
        return true;
    }
    render() {

        const { integralD } = this.state;
        return <div className="integral">
            <CommonlyHeadMembers barname='健康积分详情' />
            <div className="detailbox">
                <div className="detail">
                    <div className="detail-code"><img alt='' src={require('../../../res/images/logo.png')} /><span>{integralD.cardcode}</span><Button className="rbutton" onClick={this.open()} >修改密码</Button></div>
                    <div className="detail-div" ><span className="tname">积分：</span><span className="ty">{integralD.cardmoney}</span></div>
                    <div className="detail-div" ><span className="tname">持卡人：</span><span >{integralD.ownname}</span></div>
                    <div className="detail-div" ><span className="tname">手机号码：</span><span >{integralD.ownmobile}</span><Button className="ebutton" onClick={this.editmobile()} >修改</Button></div>
                    <div className="detail-div" ><span className="tname">持卡人身份证：</span><span >{integralD.ownid}</span></div>
                </div>
            </div>
            <div className="linkList">
                <List>
                    <List.Item arrow="horizontal"
                        onClick={() => {
                            history.push(`/members/integral/forgetPSW/${this.state.upPW.cardcode}/${this.state.publicId}`);
                            history.go();
                        }} >
                        <img alt='' src={require('../../../res/images/ka_icon1.png')} />忘记密码
               </List.Item>
                    <List.Item arrow="horizontal"
                        onClick={() => {
                            history.push(`/members/consume/${this.state.publicId}`);
                            history.go();
                        }}
                    >  <img alt='' src={require('../../../res/images/ka_icon2.png')} />交易记录
            </List.Item>
                    <List.Item arrow="horizontal"
                        onClick={() => {
                            history.push(`/members/integralSysm`);
                            history.go();
                        }}
                    >
                        <img alt='' src={require('../../../res/images/ka_icon3.png')} />使用说明
              </List.Item>
                    <List.Item arrow="horizontal"
                        onClick={() => {
                            history.push(`/members/integralSyfw/${this.state.publicId}`);
                            history.go();
                        }}
                    >
                        <img alt='' src={require('../../../res/images/ka_icon4.png')} />使用范围
               </List.Item>
                    <List.Item arrow="horizontal"
                        onClick={() => {
                            history.push(`/members/integralJqsm`);
                            history.go();
                        }}
                    >
                        <img alt='' src={require('../../../res/images/ka_icon5.png')} />检前说明
              </List.Item>
                </List>
            </div>
            <Modal
                className="editModal"
                visible={this.state.modal1}
                transparent
                closable={true}
                maskClosable={true}
                onClose={this.onClose('modal1')}
                title="修改支付密码"
                footer={[{ text: '取消', onPress: () => { this.onClose('modal1')(); } },
                { text: '确定', onPress: () => { this.Editpw('modal1')(); } }]}
                wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                afterClose={() => { }}
            >
                <div className="am-modal-input">
                    <span className="name">积分卡号：</span><input type="text" disabled name="cardcode" value={this.state.upPW.cardcode} onChange={this.handleInputChange} placeholder="" />
                </div>
                <div className="am-modal-input">
                    <span className="name">原&nbsp;&nbsp;密&nbsp;&nbsp;码：</span><input type="password" name="oldPassword" onChange={this.handleInputChange} placeholder="支付密码" />
                </div>
                <div className="am-modal-input">
                    <span className="name">新&nbsp;&nbsp;密&nbsp;&nbsp;码：</span><input type="password" name="newPassword" onChange={this.handleInputChange} placeholder="新密码（最少6位数字组成）" />
                </div>
                <div className="am-modal-input">
                    <span className="name">新&nbsp;&nbsp;密&nbsp;&nbsp;码：</span><input type="password" name="newPassword2" onChange={this.handleInputChange} placeholder="再次输入新密码" />
                </div>
            </Modal>
        </div>
    }
}